import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Instagram } from "lucide-react";
import { CreditsTicker } from "./CreditsTicker";

export const FinalCTA = () => {
  return (
    <section
      data-testid="final-cta-section"
      className="relative isolate overflow-hidden bg-loudar-ink py-32 md:py-44"
    >
      <div className="absolute inset-0 -z-10">
        <img
          src="https://images.unsplash.com/photo-1568734066241-45094773addb?auto=format&fit=crop&w=1800&q=80"
          alt=""
          className="h-full w-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-loudar-ink via-loudar-ink/85 to-loudar-ink" />
      </div>

      <div className="container-loudar relative">
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9 }}
          className="max-w-6xl font-display text-5xl uppercase leading-[0.9] tracking-tight text-white sm:text-6xl md:text-7xl lg:text-[120px]"
          data-testid="final-cta-headline"
        >
          Build Your Reputation
          <br />
          <span className="text-loudar-orange">Before</span>{" "}
          <span className="text-stroke">The Industry</span>
          <br />
          Tells Your Story For You.
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="mt-12 flex flex-wrap items-center gap-4"
        >
          <Link to="/pilot" className="btn-primary" data-testid="final-cta-apply">
            Join the waiting list <ArrowRight size={16} />
          </Link>
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noreferrer"
            className="btn-ghost"
            data-testid="final-cta-follow"
          >
            <Instagram size={16} /> Follow Loudar
          </a>
        </motion.div>
      </div>

      <div className="relative mt-20 border-y border-white/[0.06] py-4">
        <CreditsTicker />
      </div>
    </section>
  );
};

export default FinalCTA;
